import { ReactNode } from 'react';
import { Div } from '@gaiads/telia-react-component-library';
import Header from '../Header';

import styles from './DetailsPageLayout.module.scss';

interface LayoutProps {
  children: ReactNode;
}

const DetailsPageLayout = ({ children }: LayoutProps) => {
  return (
    <>
      <Div className={styles['top-level-header-container']}>
        <Header />
      </Div>
      <Div className={styles['top-level-layout-container']}>{children}</Div>
    </>
  );
};

export const DetailsPageMainContent = ({ children }: LayoutProps) => {
  return <Div className={styles['top-level-layout-container__page-content']}>{children}</Div>;
};

export const DetailsPageMainContentLeftSide = ({ children }: LayoutProps) => {
  return <Div className={styles['top-level-layout-container__page-content__left-side-content']}>{children}</Div>;
};

export const DetailsPageMainContentRightSide = ({ children }: LayoutProps) => {
  return <Div className={styles['top-level-layout-container__page-content__right-side-content']}>{children}</Div>;
};

export default DetailsPageLayout;
